<template>
  <div class="card">
    <div class="label" style="color: #707070">
      <span>{{ title }}</span>
    </div>
    <div class="card-content">
      <div class="title" style="color: #888888">{{ value }}</div>
    </div>
  </div>
</template>

<script>
import Bars from "vuebars";
import Trend from "vuetrend";

export default {
  debug_boxstat: false,
  name: "BoxStat",
  components: { Bars, Trend },
  props: {
    title: String,
    data: Array,
    male: Number,
    female: Number,
    unknown: Number,
  },
  computed: {
    icon() {
      var trend_ = ((data_array) => {
        var saida = 0;

        var a = data_array[data_array.length - 3] || 0;
        var b = data_array[data_array.length - 2] || 0;
        var c = data_array[data_array.length - 1] || 0;
        var isPositive = b > a;
        var hasTrend = (c - b) * (b - a) > 0;

        if (isPositive && hasTrend) saida = 1;
        else if (!isPositive && hasTrend) saida = -1;
        else saida = 0;

        return saida;
      })(this.data);

      var trend = "";

      if (trend_ > 0) trend = "arrow_upward";
      else if (trend_ < 0) trend = "arrow_downward";
      //else trend = "diamond";

      return trend;
    },
    icon_color() {
      var trend_ = ((data_array) => {
        var saida = 0;

        var a = data_array[data_array.length - 3] || 0;
        var b = data_array[data_array.length - 2] || 0;
        var c = data_array[data_array.length - 1] || 0;
        var isPositive = b > a;
        var hasTrend = (c - b) * (b - a) > 0;

        if (isPositive && hasTrend) saida = 1;
        else if (!isPositive && hasTrend) saida = -1;
        else saida = 0;

        return saida;
      })(this.data);

      return trend_ > 0 ? "green" : trend_ < 0 ? "red" : "blue";
    },
    data_render() {
      /* var saida = this.data || [];
      return saida.fill(1, saida.length, 7); */
      return this.data;
    },
    value() {
      var output = "";
      if (this.debug_boxstat)
        console.log(
          "this.data.length-2",
          this.data.length,
          " ",
          this.data[this.data.length - 2]
        );
      if (this.data[this.data.length - 2] == -1) {
        output = (this.data[this.data.length - 1] || 0) + "%";
        if (this.debug_boxstat) console.log(output);
      } else {
        output = this.data[this.data.length - 1] || 0;
        if (this.debug_boxstat) console.log("not ", output);
      }
      return output;
    },
    last() {
      return this.data[this.data.length - 2] || 0;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed|Titillium+Web");

div.box-icon {
  width: 36px !important;
  height: 36px !important;
}
.arrow_upward {
  display: inline-block;
  margin-right: 8px;
  width: 14px;
  height: 14px;
  border-style: solid;
  border-width: 0 8px 13px 8px;
  border-color: transparent transparent #1eeb2e transparent;
}

.arrow_downward {
  display: inline-block;
  margin-right: 8px;
  transform: rotate(180deg);
  width: 14px;
  height: 14px;
  border-style: solid;
  border-width: 0 8px 13px 8px;
  border-color: transparent transparent #eb1e36 transparent;
}

.diamond {
  display: inline-block;
  margin-right: 8px;
  transform: rotate(45deg);
  width: 16px;
  height: 16px;
  background-color: #15d3eb;
}

div.circle {
  background: #1eeb2e;
  display: inline-block;
  margin: 0 0 2px 0;
  border-radius: 50%;
  height: 12px;
  width: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/BoxStat.vue